import { Component, Input } from '@angular/core'
import { LoaderLinkComponent } from 'shared-lib'

@Component({
  selector: 'automation-loader',
  standalone: true,
  imports: [LoaderLinkComponent],
  template: ` <cnect-loader-link
    [active]="isLoading"
    [size]="'lg'"
    [label]="label"
    fontColor="e11-text-skin-white"
    [hasBackdrop]="true"
    [fullScreen]="true"
  ></cnect-loader-link>`,
})
export class AutomationLoaderComponent {
  @Input() isLoading: boolean = false
  @Input() label: string = 'Uploading attachment...'
}
